import { computed, makeObservable, observable, runInAction } from "mobx";
import { RootStore } from "./RootStore";
import { Note } from "../models/Note";

class NoteStore {
  rootStore: RootStore;
  notes: Note[] | undefined = undefined;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    makeObservable(this, {
      notes: observable,
      latestNotes: computed
    });
  }

  get latestNotes() {
    if(!this.notes) {
      return [];
    }
    return [] as Note[];
  }

  setNotes(newNotes: Note[] | undefined) {
    runInAction(() => {
      this.notes = newNotes ?? [];
    })
  }

  getNotes = async () => {
    this.setNotes([])
  }

}

export default NoteStore;
